(function dynamicTextDirectiveDefinition() {
    'use strict';

    angular.module('CustomControlComboMultiple', [])
        .directive('dynamicComboMultiple', ['adminMetadataService', 'errorsExtend',
            function (adminMetadataService, errors) {
                return {
                    replace: true,
                    restrict: 'E',
                    templateUrl: '/app/directives/custom-control-combo-multiple/custom-control-combo-multiple-template.html',
                    controller: [
                        '$scope', function ($scope) {
                            $scope.value = '';

                            if ($scope.data && $scope.data.metadataOptions && (typeof $scope.data.metadataOptions === 'string')) {
                                $scope.data.metadataOptions = $.parseJSON($scope.data.metadataOptions);
                            }

                            if ($scope.data.metadataValue) {
                                function isOnMetadataValue(option) {
                                    return $scope.data.metadataValue.indexOf(option.value) > -1;
                                }

                                $scope.data.metadataValue = Array.isArray($scope.data.metadataValue) ? $scope.data.metadataValue : JSON.parse($scope.data.metadataValue);
                            }

                            $scope.selectMetadata = function (metadata) {
                                if (!Array.isArray(this.data.metadataValue)) {
                                    this.data.metadataValue = [];
                                }
                            };

                            $scope.removeMetadata = function (metadata) {
                                var index = this.data.metadataValue.indexOf(metadata.value);
                                if (index > -1) {
                                    this.data.metadataValue.splice(index, 1);
                                }
                            };

                            $scope.save = function () {
                                if (this.$parent.value) {
                                    var item = {
                                        metadataId: this.$parent.data.metadataId,
                                        key: this.$parent.value
                                    };
                                    adminMetadataService.addMetadataValues(item).then(function (result) {
                                        $scope.addToOptions(result);
                                    }, function (error) {
                                        errors.showError(error);
                                    });
                                }
                                else {
                                    errors.showError('VerifyFormData');
                                }
                            };

                            $scope.cancel = function () {
                                this.value = '';
                            };

                            $scope.addToOptions = function (result) {
                                this.data.metadataOptions.push({ value: result.key });
                                this.value = '';
                                $('#addItemModal' + this.data.metadataId).modal('hide');
                            };
                        }]
                };
            }]);

    angular.module('CustomControlComboMultiple')
        .directive('dynamicFilterComboMultiple', ['$translate', function () {
            return {
                templateUrl: '/app/directives/custom-control-combo-multiple/custom-control-filter-combo-multiple-template.html',
                replace: true,
                restrict: 'E',
                controller: [
                    '$scope', function ($scope) {

                        $scope.data.tempMetadataValue = [];

                        if ($scope.data && !$scope.data.metadataSearchTypeFrom) {
                            $scope.data.metadataSearchTypeFrom = 'All';
                        }

                        if ($scope.data && $scope.data.metadataOptions && (typeof $scope.data.metadataOptions === 'string')) {
                            $scope.data.metadataOptions = $.parseJSON($scope.data.metadataOptions);
                        }

                        if ($scope.data.metadataValueFrom) {
                            function isOnMetadataValue(option) {
                                return $scope.data.metadataValueFrom.indexOf(option.value) > -1;
                            }

                            var selectedOptions = $scope.data.metadataOptions.filter(isOnMetadataValue);

                            if (!$scope.data.tempmetadataValueFrom) {
                                $scope.data.tempmetadataValueFrom = [];
                            }

                            selectedOptions.forEach(function (item, index) {
                                $scope.data.tempmetadataValueFrom.push(item);
                            });
                        }

                        $scope.selectMetadata = function (metadata) {
                            if (!Array.isArray(this.data.metadataValueFrom)) {
                                this.data.metadataValueFrom = [];
                            }

                            this.data.metadataValueFrom.push(metadata.value);
                        };

                        $scope.removeMetadata = function (metadata) {
                            var index = this.data.metadataValueFrom.indexOf(metadata.value);
                            if (index > -1) {
                                this.data.metadataValueFrom.splice(index, 1);
                            }
                        };


                        $scope.onNullChanged = function (data) {
                            if (this.data.nullValue) {
                                this.data.metadataValueFrom = [];
                                this.data.tempMetadataValue = [];
                            }
                        };
                    }
                ],
                link: function (scope, iElement, iAttrs, formCtrl) {
                    scope.filterNullValue = iAttrs.filternullvalue;
                }
            };
        }]);
})();